var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const getInput = /* @__PURE__ */ __name((frame) => frame.querySelector("input"), "getInput");

export { getInput };
//# sourceMappingURL=get-input.js.map
